module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-excel-14d7b0f5.svg";